export default __webpack_public_path__ + "static/media/electricity.f945009b.svg";